// Admin allowlist - emails authorized to access the dashboard.
// Must also be present in the backend ADMIN_EMAILS env var on Render —
// this list only gates what the frontend renders; the backend API enforces
// admin access independently via middleware/adminAuth.js.
export const ALLOWED_ADMINS = [
  'abhijeet.roy@gmail.com',
  'satishshetty@gmail.com',
  'abhijeetroy@jeevibe.com',
  'satishshetty@jeevibe.com',
];

// Check if an email is in the admin allowlist
export function isAllowedAdmin(email) {
  if (!email) return false;

  // If no admins configured, allow all (for initial setup)
  // Remove this check in production!
  if (ALLOWED_ADMINS.length === 0) {
    console.warn('No admin emails configured. Allowing all authenticated users.');
    return true;
  }

  return ALLOWED_ADMINS.includes(email.toLowerCase());
}
